import {
  Dashboard,
  DashboardType,
  Organization,
  OrganizationPermission,
} from 'src/types';
import { ROUTES } from './routes';

export const getGarmDashboards = (organization: Organization): Dashboard[] => {
  return organization.dashboards.filter(
    (dashboard) =>
      dashboard.type === DashboardType.MAIN ||
      dashboard.type === DashboardType.GARM
  );
};

export const canAccessDashboard = (
  permission?: OrganizationPermission | null
): boolean =>
  !permission || permission === 'all-access' || permission === 'dashboard-only';

export const canAccessCampaigns = (
  permission?: OrganizationPermission | null
): boolean =>
  !permission || permission === 'all-access' || permission === 'campaigns-only';

export const getDefaultAuthenticatedRoute = (
  permission?: OrganizationPermission | null
): string =>
  permission === 'campaigns-only' ? ROUTES.CAMPAIGNS : ROUTES.DASHBOARD;
